import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { Badge } from 'react-bootstrap'
import batIcon from '@assets/images/icon/cricket-bat.svg'
import styles from './style.module.scss'
import FlagTeam from '@assets/images/placeholder/team-placeholder.svg'

import { S3_PREFIX } from '@shared-submodule/sm-constants'
import { useQuery, useSubscription } from '@apollo/client'
import { GET_MATCH_HEADER, MATCH_DETAIL_FOR_CLIENT } from '@graphql/match/match.subscription'
import { CupIcon } from '@shared/components/ctIcons'
import trophyIcon from '@assets/images/icon/trophy-icon.svg'
import playerPlaceholder from '@assets/images/placeholder/playerPagePlaceholder.svg'
import CustomLink from '@shared/components/customLink'
import useWindowSize from '@shared/hooks/windowSize'
import useStatus from '@shared-submodule/sm-hooks/useStatus'
const Header = dynamic(() => import('./header'))
const MyImage = dynamic(() => import('@shared/components/myImage'))
const RecentOver = dynamic(() => import('@shared/components/match/recentOver'), { ssr: false, loading: () => <div style={{ height: '40px' }} /> })

export default function Result({ data, is100 }) {
  const { sStatusStr, sStatus } = useStatus(data)
  const [liveData, setLiveData] = useState(data)
  const { data: updatedData } = useSubscription(GET_MATCH_HEADER, { variables: { input: { iMatchId: data?._id } }, skip: typeof window === 'undefined' })

  const [width] = useWindowSize()

  // Remove once proxy cache issue fixed (temporary)
  useQuery(MATCH_DETAIL_FOR_CLIENT, {
    variables: { input: { _id: data?._id } },
    onCompleted: (data) => {
      if (data?.getMatchById) setLiveData({ ...liveData, ...data?.getMatchById })
    }
  })

  useEffect(() => {
    // updating the scores on title of the page for live matches only
    if (typeof document !== 'undefined' && sStatusStr === 'live') {
      if (liveData?.oTeamScoreA?.sScoresFull?.includes('*')) {
        document.title = (liveData?.oTeamScoreA?.oTeam?.sAbbr || liveData?.oTeamScoreA?.oTeam?.sTitle) + (liveData?.oTeamScoreA?.sScoresFull ? ' ' + liveData?.oTeamScoreA?.sScoresFull + '' : '') + ' vs ' + (liveData?.oTeamScoreB?.oTeam?.sAbbr || liveData?.oTeamScoreB?.oTeam?.sTitle) + (liveData?.oTeamScoreB?.sScoresFull ? ' ' + liveData?.oTeamScoreB?.sScoresFull + '' : '') + ', ' + (liveData?.oSeries?.sTitle)
      } else if (data?.oTeamScoreB?.sScoresFull?.includes('*')) {
        document.title = (liveData?.oTeamScoreB?.oTeam?.sAbbr || liveData?.oTeamScoreB?.oTeam?.sTitle) + (liveData?.oTeamScoreB?.sScoresFull ? ' ' + liveData?.oTeamScoreB?.sScoresFull + '' : '') + ' vs ' + (liveData?.oTeamScoreA?.oTeam?.sAbbr || liveData?.oTeamScoreA?.oTeam?.sTitle) + (liveData?.oTeamScoreA?.sScoresFull ? ' ' + liveData?.oTeamScoreA?.sScoresFull + '' : '') + ', ' + (liveData?.oSeries?.sTitle)
      }
    }
  }, [])

  useEffect(() => {
    // updating the scores on title of the page for live matches only on data change
    if (updatedData?.getMatchBySlug?.oMatchDetailsFront) {
      if (typeof document !== 'undefined' && sStatusStr === 'live') {
        const newData = updatedData?.getMatchBySlug?.oMatchDetailsFront
        if (newData?.oTeamScoreA?.sScoresFull?.includes('*')) {
          document.title = (data?.oTeamScoreA?.oTeam?.sAbbr || data?.oTeamScoreA?.oTeam?.sTitle) + (newData?.oTeamScoreA?.sScoresFull ? ' ' + newData?.oTeamScoreA?.sScoresFull + '' : '') + ' vs ' + (data?.oTeamScoreB?.oTeam?.sAbbr || data?.oTeamScoreB?.oTeam?.sTitle) + (newData?.oTeamScoreB?.sScoresFull ? ' ' + newData?.oTeamScoreB?.sScoresFull + '' : '') + ', ' + (data?.oSeries?.sTitle)
        } else if (newData?.oTeamScoreB?.sScoresFull?.includes('*')) {
          document.title = (data?.oTeamScoreB?.oTeam?.sAbbr || data?.oTeamScoreB?.oTeam?.sTitle) + (newData?.oTeamScoreB?.sScoresFull ? ' ' + newData?.oTeamScoreB?.sScoresFull + '' : '') + ' vs ' + (data?.oTeamScoreA?.oTeam?.sAbbr || data?.oTeamScoreA?.oTeam?.sTitle) + (newData?.oTeamScoreA?.sScoresFull ? ' ' + newData?.oTeamScoreA?.sScoresFull + '' : '') + ', ' + (data?.oSeries?.sTitle)
        }
      }
      setLiveData({ ...liveData, ...updatedData?.getMatchBySlug?.oMatchDetailsFront })
    }
  }, [updatedData])

  useEffect(() => {
    setLiveData(data)
  }, [data])

  const currentTeamData = ['completed', 'cancelled'].includes(sStatusStr) ? data?.aInning?.[0] : data?.aInning?.[data?.aInning?.length - 1]
  const currentBattingTeamId = currentTeamData?.iBattingTeamId
  const isCurrentBatting = currentBattingTeamId === data?.oTeamScoreA?.oTeam?._id
  const TeamBscore = (liveData?.oTeamScoreB?.sScores !== null && liveData?.oTeamScoreB?.sOvers !== null) && `${liveData?.oTeamScoreB?.sScores} (${liveData?.oTeamScoreB?.sOvers}${is100 ? '' : ' ov'})`
  const TeamAscore = (liveData?.oTeamScoreA?.sScores !== null && liveData?.oTeamScoreA?.sOvers !== null) && `${liveData?.oTeamScoreA?.sScores} (${liveData?.oTeamScoreA?.sOvers}${is100 ? '' : ' ov'})`
  return (
    <>
      <section className={styles.matchHeader}>
        <Header data={data} />
        <div className={`${styles.matchInfo} mb-2 mb-md- mb-xl-0`}>
          <div className='row'>
            <div className={sStatusStr === 'completed' && liveData?.oMom?.sFullName ? 'col-md-7 col-sm-12 px-2' : 'col-12 px-2'}>
              <div className={`${styles.teams} ${(liveData?.sBallEvent && liveData?.sBallEvent !== '' && liveData?.sBallEvent !== null) ? styles.liveTeams : ''} flex-grow-1`}>
                <div className={`${styles.team} d-flex align-items-center justify-content-between flex-shrink-0 ${(liveData?.sBallEvent && liveData?.sBallEvent !== '' && liveData?.sBallEvent !== null) ? styles.liveMatchTeam : ''}`}>
                  <CustomLink href={(isCurrentBatting && data?.oTeamScoreA?.oSeo?.sSlug) ? `/${data?.oTeamScoreA?.oSeo?.sSlug}` : (data?.oTeamScoreB?.oSeo?.sSlug ? `/${data?.oTeamScoreB?.oSeo?.sSlug}` : '')}>
                    <a>
                      <div className={`${styles.name} d-flex align-items-center`}>
                        <div className={`${styles.flag}`}>
                          {isCurrentBatting ? <MyImage
                            placeholderImage={FlagTeam}
                            src={data?.oTeamScoreA?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${data?.oTeamScoreA?.oTeam?.oImg?.sUrl}` : FlagTeam}
                            alt={data?.oTeamScoreA?.oTeam?.sAbbr}
                            layout="responsive"
                            width="20"
                            height="20"
                            autoRadiusImage
                            sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
                          /> : <MyImage
                            placeholderImage={FlagTeam}
                            src={data?.oTeamScoreB?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${data?.oTeamScoreB?.oTeam?.oImg?.sUrl}` : FlagTeam}
                            alt={data?.oTeamScoreB?.oTeam?.sAbbr}
                            layout="responsive"
                            width="20"
                            height="20"
                            sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
                          />}
                        </div>
                        {isCurrentBatting ? <p className="big-text font-semi d-flex">
                          {data?.oTeamScoreA?.oTeam?.sAbbr || data?.oTeamScoreA?.oTeam?.sTitle}
                          {sStatusStr === 'completed' && data?.oTeamScoreA?.oTeam?._id === data?.oWinner?._id && <span className={`${styles.winner} ms-2`}><CupIcon /></span>}
                          {
                            sStatusStr === 'live' && data?.oTeamScoreA?.sScoresFull?.includes('*') && (
                              <div className={styles.batImg}>
                                <MyImage src={batIcon} alt='fixtures' layout="responsive" width="5" height="5" />
                              </div>
                            )}
                        </p> : <p className="big-text font-semi d-flex">
                          {data?.oTeamScoreB?.oTeam?.sAbbr || data?.oTeamScoreB?.oTeam?.sTitle}
                          {sStatusStr === 'completed' && data?.oTeamScoreB?.oTeam?._id === data?.oWinner?._id && <span className={`${styles.winner} ms-2`}><CupIcon /></span>}
                          {
                            sStatusStr === 'live' && data?.oTeamScoreB?.sScoresFull?.includes('*') && (
                              <div className={styles.batImg}>
                                <MyImage src={batIcon} alt='fixtures' layout="responsive" width="5" height="5" />
                              </div>
                            )}
                        </p>}
                      </div>
                    </a>
                  </CustomLink>
                  {isCurrentBatting ? liveData?.nLatestInningNumber === 1 &&
                    (liveData?.oTeamScoreA?.sScoresFull ? (
                      <p className={`${styles.score} big-text orig-theme font-bold`}>{liveData?.oTeamScoreA?.sScoresFull}</p>
                      // <p className={`${styles.score} big-text orig-theme font-bold`}>{TeamAscore}</p>
                    ) : (
                      sStatusStr === 'cancelled' ? '' : <p className={`${styles.score} big-text text-secondary font-bold`}>{'Yet To Bat'}</p>
                    )) : liveData?.nLatestInningNumber === 1 &&
                  (liveData?.oTeamScoreB?.sScoresFull ? (
                    <p className={`${styles.score} big-text orig-theme font-bold`}>{liveData?.oTeamScoreB?.sScoresFull}</p>
                    // <p className={`${styles.score} big-text orig-theme font-bold`}>{TeamBscore}</p>
                  ) : (
                    <p className={`${styles.score} big-text text-secondary font-bold`}>{'Yet To Bat'}</p>
                  ))}
                  {isCurrentBatting ? liveData?.nLatestInningNumber > 1 &&
                    (liveData?.oTeamScoreA?.sScoresFull?.includes('*') ? (
                      // <p className={`${styles.score} big-text orig-theme font-bold`}>{liveData?.oTeamScoreA?.sScoresFull}</p>
                      <p className={`${styles.score} big-text orig-theme font-bold`}>{TeamAscore}</p>
                    ) : (
                      // <p className={`${styles.score} big-text text-secondary font-bold`}>{liveData?.oTeamScoreA?.sScoresFull}</p>
                      <p className={`${styles.score} big-text text-secondary font-bold`}>{TeamAscore}</p>
                    )) : liveData?.nLatestInningNumber > 1 &&
                  (liveData?.oTeamScoreB?.sScoresFull?.includes('*') ? (
                    // <p className={`${styles.score} big-text orig-theme font-bold`}>{liveData?.oTeamScoreB?.sScoresFull}</p>
                    <p className={`${styles.score} big-text orig-theme font-bold`}>{TeamBscore}</p>
                  ) : (
                    // <p className={`${styles.score} big-text text-secondary font-bold`}>{liveData?.oTeamScoreB?.sScoresFull}</p>
                    <p className={`${styles.score} big-text text-secondary font-bold`}>{TeamBscore}</p>
                  ))}
                </div>
                <div className={`${styles.team} d-flex align-items-center justify-content-between flex-shrink-0 ${(liveData?.sBallEvent && liveData?.sBallEvent !== '' && liveData?.sBallEvent !== null) ? styles.liveMatchTeam : ''}`}>
                  <CustomLink href={(!isCurrentBatting && data?.oTeamScoreA?.oSeo?.sSlug) ? `/${data?.oTeamScoreA?.oSeo?.sSlug}` : (data?.oTeamScoreB?.oSeo?.sSlug ? `/${data?.oTeamScoreB?.oSeo?.sSlug}` : '')}>
                    <a>
                      <div className={`${styles.name} d-flex align-items-center`}>
                        <div className={`${styles.flag}`}>
                          {!isCurrentBatting ? <MyImage
                            placeholderImage={FlagTeam}
                            src={data?.oTeamScoreA?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${data?.oTeamScoreA?.oTeam?.oImg?.sUrl}` : FlagTeam}
                            alt={data?.oTeamScoreA?.oTeam?.sAbbr}
                            layout="responsive"
                            width="20"
                            height="20"
                            autoRadiusImage
                            sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
                          /> : <MyImage
                            placeholderImage={FlagTeam}
                            src={data?.oTeamScoreB?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${data?.oTeamScoreB?.oTeam?.oImg?.sUrl}` : FlagTeam}
                            alt={data?.oTeamScoreB?.oTeam?.sAbbr}
                            layout="responsive"
                            width="20"
                            height="20"
                            sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
                          />}
                        </div>
                        {!isCurrentBatting ? <p className="big-text font-semi d-flex">
                          {data?.oTeamScoreA?.oTeam?.sAbbr || data?.oTeamScoreA?.oTeam?.sTitle}
                          {sStatusStr === 'completed' && data?.oTeamScoreA?.oTeam?._id === data?.oWinner?._id && <span className={`${styles.winner} ms-2 d-inline-block`}><CupIcon /></span>}
                          {
                            sStatusStr === 'live' && data?.oTeamScoreA?.sScoresFull?.includes('*') && (
                              <div className={styles.batImg}>
                                <MyImage src={batIcon} alt='fixtures' layout="responsive" width="5" height="5" />
                              </div>
                            )}
                        </p> : <p className="big-text font-semi  d-flex">
                          {data?.oTeamScoreB?.oTeam?.sAbbr || data?.oTeamScoreB?.oTeam?.sTitle}
                          {sStatusStr === 'completed' && data?.oTeamScoreB?.oTeam?._id === data?.oWinner?._id && <span className={`${styles.winner} ms-2 d-inline-block`}><CupIcon /></span>}
                          {
                            sStatusStr === 'live' && data?.oTeamScoreB?.sScoresFull?.includes('*') && (
                              <div className={styles.batImg}>
                                <MyImage src={batIcon} alt='fixtures' layout="responsive" width="5" height="5" />
                              </div>
                            )}
                        </p>}
                      </div>
                    </a>
                  </CustomLink>
                  <div>
                    {!isCurrentBatting ? liveData?.nLatestInningNumber === 1 &&
                      (liveData?.oTeamScoreA?.sScoresFull ? (
                        // <p className={`${styles.score} big-text orig-theme font-semi`}>{liveData?.oTeamScoreA?.sScoresFull}</p>
                        <p className={`${styles.score} big-text orig-theme font-semi`}>{TeamAscore}</p>
                      ) : (
                        // <p className={`${styles.score} big-text text-secondary font-semi`}></p>
                        sStatusStr === 'cancelled' ? '' : <p className={`${styles.score} big-text text-secondary font-semi`}>{'Yet To Bat'}</p>
                      )) : liveData?.nLatestInningNumber === 1 &&
                    (liveData?.oTeamScoreB?.sScoresFull ? (
                      // <p className={`${styles.score} big-text orig-theme font-semi`}>{liveData?.oTeamScoreB?.sScoresFull}</p>
                      <p className={`${styles.score} big-text orig-theme font-semi`}>{TeamBscore}</p>
                    ) : (
                      sStatusStr === 'cancelled' ? '' : <p className={`${styles.score} big-text text-secondary font-semi`}>{'Yet To Bat'}</p>
                    ))}
                    {!isCurrentBatting ? liveData?.nLatestInningNumber > 1 &&
                      (liveData?.oTeamScoreA?.sScoresFull?.includes('*') ? (
                        // <p className={`${styles.score} big-text orig-theme font-semi`}>{liveData?.oTeamScoreA?.sScoresFull}</p>
                        <p className={`${styles.score} big-text orig-theme font-semi`}>{TeamAscore}</p>
                      ) : (
                        // <p className={`${styles.score} big-text text-secondary font-semi`}>{liveData?.oTeamScoreA?.sScoresFull}</p>
                        <p className={`${styles.score} big-text text-secondary font-semi`}>{TeamAscore}</p>
                      )) : liveData?.nLatestInningNumber > 1 &&
                    (liveData?.oTeamScoreB?.sScoresFull?.includes('*') ? (
                      // <p className={`${styles.score} big-text orig-theme font-semi`}>{liveData?.oTeamScoreB?.sScoresFull}</p>
                      <p className={`${styles.score} big-text orig-theme font-semi`}>{TeamBscore}</p>
                    ) : (
                      // <p className={`${styles.score} big-text text-secondary font-semi`}>{liveData?.oTeamScoreB?.sScoresFull}</p>
                      <p className={`${styles.score} big-text text-secondary font-semi`}>{TeamBscore}</p>
                    ))}
                  </div>
                </div>
                {
                  (sStatusStr === 'live' && liveData?.sBallEvent && liveData?.sBallEvent !== '' && liveData?.sBallEvent !== null) && (
                    <div className={`${styles.ballScore} text-capitalize ${liveData?.sBallEvent.indexOf(' ') === -1 ? styles.ballScoreOneWord : ''}`}><p>{liveData?.sBallEvent.length > 25 && width < 357 ? liveData?.sBallEvent.substring(0, 25) + '...' : liveData?.sBallEvent.length > 45 ? liveData?.sBallEvent.substring(0, 45) + '...' : liveData?.sBallEvent}</p></div>
                  )
                }
              </div>
              {/* <div className={`${styles.redFont} mb-2`}>
                {liveData?.sStatusNote || liveData?.sLiveMatchNote}
              </div> */}
              {/* {sStatusStr !== 'completed' &&
               <div className={`${styles.redFont} mb-2`}>
               {liveData?.sStatusNote || liveData?.sLiveMatchNote}
             </div>} */}

            </div>
            {(sStatusStr === 'completed' && liveData?.oMom?.sFullName) && (
              <div className={`${styles.alignAround} col-md-5 col-sm-12`}>
                <div className={`${styles.manOfTheMatch} common-box d-flex text-center p-0 mb-2 mb-md- mb-xl-0 align-items-center`}>
                  <div className={`${styles.momImage} position-relative font-bold`}>
                    {/* <MyImage src={playerPlaceholder} alt="MOM" layout="fill" /> */}
                    {/* <CustomLink href={data?.oPlayer?.oSeo?.sSlug ? `/${data?.oPlayer?.oSeo?.sSlug}` : ''} prefetch={false}>
                    <a className={`${styles.imgBlock} d-block m-auto ${data?.oPlayer?.eTagStatus === 'a' ? '' : 'disabled'}`}> */}
                    <MyImage
                      src={liveData?.oMom?.oImg?.sUrl ? `${S3_PREFIX}${liveData?.oMom?.oImg?.sUrl}` : playerPlaceholder}
                      width="162"
                      height="162"
                      alt={liveData?.oMom?.oImg?.sText || 'Player Image'}
                      layout="responsive"
                    />
                    {/* </a>
                   </CustomLink> */}
                  </div>
                  <div className="flex-grow-1 px-1">
                    <span className={`${styles.icon} d-block mb-1 mb-md-2 mx-auto`}>
                      <MyImage src={trophyIcon} alt="trophy" layout="responsive" />
                    </span>
                    <p className={`${styles.momTitle} xsmall-text mb-0 mb-md-1`}>
                      {'Player of the Match'}
                    </p>
                    <p className={`${styles.momName} xsmall-text mb-0 font-bold`}>
                      {
                        liveData?.oMom?.eTagStatus === 'a' ? (
                          <CustomLink href={`/${liveData?.oMom?.oSeo?.sSlug}`}>
                            {liveData?.oMom?.sFullName}
                          </CustomLink>
                        ) : (
                          liveData?.oMom?.sFullName
                        )
                      }
                    </p>
                  </div>
                </div>
              </div>
            )}
            {/* {(sStatusStr === 'completed' && liveData?.oMos?.sFullName) && (
              <p className="text-secondary">
                {"Man of the Series"} :  {liveData?.oMos?.sFullName}
              </p>
            )} */}
            {/* </div> */}
            <div className='d-flex mb-2'>
              {(liveData?.oLiveScore?.nRunrate > 0 && sStatusStr !== 'completed') && (
                <div>
                  <span className='text-muted mr-1'>
                    {width > 395 ? ('Current Run Rate:') : ('CR Rate:')}
                  </span>
                  <span className='fw-bold'>&nbsp; {liveData?.oLiveScore?.nRunrate}</span>
                </div>
              )}
              {(liveData?.oLiveScore?.sRequiredRunrate && sStatusStr !== 'completed') && (
                <div className=' mx-3'>
                  <span className='text-muted'> {width > 395 ? ('Required Run Rate:') : ('RR Rate:')}
                  </span>
                  <span className='fw-bold'>&nbsp; {liveData?.oLiveScore?.sRequiredRunrate}</span>
                </div>)}
            </div>
          </div>
          <div className={`${styles.result} d-flex align-items-center `}>
            {sStatusStr === 'live' && (
              <><Badge bg="danger" className={`${styles.badge} me-2 me-xl-3 text-uppercase`}>
                <span>{sStatus}</span>
              </Badge>
                <span>
                  {liveData?.sStatusNote || liveData?.sLiveMatchNote}
                </span>
              </>
            )}
            {sStatusStr === 'completed' && (
              <><Badge bg="success" className={`${styles.badge} me-2 me-xl-3 text-uppercase`}>
                <span>{sStatus}</span>
              </Badge>
                <span>
                  {liveData?.sStatusNote || liveData?.sLiveMatchNote}
                </span>
              </>
            )}
            {sStatusStr === 'cancelled' && (
              <><Badge bg="danger" className={`${styles.badge} me-2 me-xl-3 text-uppercase`}>
                <span>{sStatus}</span>
              </Badge>
                <span>
                  {liveData?.sStatusNote || liveData?.sLiveMatchNote}
                </span>
              </>
            )}

            {/* {(liveData?.oLiveScore?.nRunrate > 0 && sStatusStr !== 'completed' ) && (
              <div>
                <span className='text-muted mr-1'>
                {width > 395 ? ('Current Run Rate:') : ('CR Rate:')}
                </span>
                <span className='fw-bold'>&nbsp; {liveData?.oLiveScore?.nRunrate}</span>
              </div>
            )}
            {(liveData?.oLiveScore?.sRequiredRunrate && sStatusStr !== 'completed' )  && (
              <div className=' mx-3'>
              <span className='text-muted'> {width > 395 ? ('Required Run Rate:') : ('RR Rate:')}
              </span>
                <span className='fw-bold'>&nbsp; {liveData?.oLiveScore?.sRequiredRunrate}</span>
              </div>)} */}
          </div>
        </div>
        {/* </Row> */}
        <div className='mt-3'>
          {sStatusStr !== 'scheduled' && <RecentOver matchDetail={data} is100={is100} />}
        </div>
      </section>
    </>
  )
}

Result.propTypes = {
  data: PropTypes.object,
  is100: PropTypes.bool
}
